import { useMemo } from 'react';
import { columnWidths } from '../utilities';
export var useTableColumnWidths = function useTableColumnWidths(columns, columnOrder) {
  return useMemo(function () {
    // If columnOrder is provided, place the columns in the order specified
    return columnWidths(columns, columnOrder);
  }, [columns, columnOrder]);
};